import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollegePage } from '../../models/college-dashboard.model';

interface NavItem {
  label: CollegePage;
  iconType: 'dashboard' | 'users' | 'briefcase' | 'target' | 'bell' | 'settings';
}

@Component({
  selector: 'app-college-sidebar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './college-sidebar.component.html',
  styleUrl: './college-sidebar.component.scss'
})
export class CollegeSidebarComponent {
  @Input() activePage: CollegePage = 'Overview';
  @Input() unreadCount: number = 0;
  @Input() institutionName: string = 'P.K. College of Engineering';
  @Input() placementOfficer: string = 'Placement Officer';
  @Input() isCollapsed = false;

  @Output() pageChange = new EventEmitter<CollegePage>();
  @Output() openHelp = new EventEmitter<void>();
  @Output() logout = new EventEmitter<void>();
  @Output() toggleCollapse = new EventEmitter<void>();

  navItems: NavItem[] = [
    { label: 'Overview', iconType: 'dashboard' },
    { label: 'Students', iconType: 'users' },
    { label: 'Companies & Jobs', iconType: 'briefcase' },
    // { label: 'Placement Readiness', iconType: 'target' },
    // Not yet wired to real data/functionality — hidden until ready.
    // { label: 'Notifications', iconType: 'bell' },
    // { label: 'Settings', iconType: 'settings' }
  ];

  selectPage(page: CollegePage): void {
    this.pageChange.emit(page);
  }

  onLogout(): void {
    this.logout.emit();
  }

  onToggleCollapse(): void {
    this.toggleCollapse.emit();
  }

  get initials(): string {
    return (
      this.placementOfficer
        .split(' ')
        .map((n) => n[0])
        .join('')
        .substring(0, 2)
        .toUpperCase() || 'PO'
    );
  }
}
